/**
 * Created by RSchweber-Koren on 1/9/2017.
 */

import Assert from "tbAssert";

import angular from "angular";
import uiRouterModule from "@uirouter/angularjs";

import AppInsightsProvider from "./AppInsightsProvider";
import AppInsightsEventHandlerService from "./AppInsightsEventHandlerService";
import TbLoginViewModuleConstants from "tbClient/views/tb-login-view/Constants";
import AuthCallbackViewModuleConstants from "tbClient/views/auth-callback/Constants";

function SetupAppInsightsTransitionHooks($transitions, $state, $log) {

    Assert.StrictAssert($transitions != null, "Transitions Service dependency missing or invalid");
    Assert.StrictAssert($state != null, "Ui Router State Service dependency missing or invalid");
    Assert.StrictAssert($log != null, "Log Service dependency missing or invalid");
    $log.debug("Initializing App Insights Transition Hooks");

    //const startHookCriteria = {
    //    //exclude coming from a null state and coming from the callback state.
    //    from: (state) =>
    //        (state) &&
    //        (state.name) &&
    //        (state.name.trim() !== "") &&
    //        (state.name !== AuthCallbackViewModuleConstants.rootStateName)
    //};


    const loginPageOnlyCriteria = {
        to: (state) => (state.name === TbLoginViewModuleConstants.rootStateName)
    };
    $transitions.onSuccess(loginPageOnlyCriteria, (transition) => {
        const appInsightsTrackingSvc = transition.injector().get(AppInsightsEventHandlerService.ServiceName);
        return appInsightsTrackingSvc.onSinglePageView(transition);
    });

    const completedHookCriteria = {
        //exclude successful transitions into the login page or the auth callback state
        to: (state) => (
            (state.name !== TbLoginViewModuleConstants.rootStateName) &&
            (state.name !== AuthCallbackViewModuleConstants.rootStateName))
    };
    $transitions.onSuccess(completedHookCriteria, (transition) => {
        const appInsightsTrackingSvc = transition.injector().get(AppInsightsEventHandlerService.ServiceName);
        return appInsightsTrackingSvc.onSinglePageView(transition);
    });

    $log.debug("Finished Initializing App Insights Transition Hooks");
}

SetupAppInsightsTransitionHooks.$inject = [
    "$transitions",
    "$state",
    "$log",
    "appInsightsEventHandlerSvc"
];

export default angular
    .module("trackerbase-app.services.app-insights",[
        uiRouterModule
    ])
    .provider("appInsights", AppInsightsProvider) //Note: Provider during config phase is "appInsightsProvider"
    .service(AppInsightsEventHandlerService.ServiceName, AppInsightsEventHandlerService)
    .run(SetupAppInsightsTransitionHooks)
    .name;



//////////////////
// WEBPACK FOOTER
// ./src/services/AppInsights/index.js
// module id = VBTl
// module chunks = 1